/**
 * Class Service
 */

import api from '../lib/api';

export const classService = {
  async getAll(params = {}) {
    const response = await api.get('/classes', { params });
    return response.data;
  },

  async getById(id) {
    const response = await api.get(`/classes/${id}`);
    return response.data;
  },

  async create(data) {
    const response = await api.post('/classes', data);
    return response.data;
  },

  async update(id, data) {
    const response = await api.put(`/classes/${id}`, data);
    return response.data;
  },

  async delete(id) {
    const response = await api.delete(`/classes/${id}`);
    return response.data;
  },

  async getEnrollments(id) {
    const response = await api.get(`/classes/${id}/enrollments`);
    return response.data;
  }
};
